import TestOrderForm from "./TestOrderForm";

const Index = () => {
  return <TestOrderForm />;
};

export default Index;
